(function ($) {
	$(".news-card").slice(0, 10).show();

	$(".load_posts").on("click", function (e) {
		e.preventDefault();
		$(".news-card:hidden").slice(0, 10).slideDown();

		if ($(".news-card:hidden").length == 0) {
			$(this).fadeOut("slow");
		}
	});
})(jQuery);
